import { LocationTypes } from '../../constants';
import encodeAddressAutocompleteObj from './encodeAddressAutocompleteObj';
import encodeGeonameAirportObj from './encodeGeonameAirportObj';

const encodeLocationTypeObj = (autocomplete) => {
  if (autocomplete.locationType === LocationTypes.PORT_OF_DEPARTURE) {
    return {
      portId: autocomplete.value,
      label: autocomplete.label,
    };
  } if (autocomplete.locationType === LocationTypes.AIRPORT || autocomplete.airportCode) {
    return encodeGeonameAirportObj(autocomplete);
  }
  return encodeAddressAutocompleteObj(autocomplete);
};

export default encodeLocationTypeObj;
